import axios from 'axios';
import { FEEDBACK_BASE_PATH } from './api-base-paths';



export const SubmitFeedbackForm = (data) => {
    try {
      return axios.post(`${FEEDBACK_BASE_PATH}/submit-form`,data);
    } catch (error) {
      console.log('Error in Submitting Feedback Form', error);
      throw error;
    }
  };



